<template>
    <teleport to="#modal">
        <Loading
            :visible="lista.loading"
        >
        </Loading>
    </teleport>

    <teleport to="#modal">
        <Modal v-model:visible="visible" :backdrop="true">
            <template #header>
                <p class="font-bold text-xl mb-3">Importa costi timesheet</p>
            </template>
            <template #main>
                <div class="flex items-end gap-3">
                    <div class="flex justify-center mb-3">
                        <FileUpload
                            v-model:uploaded_files="uploaded"
                            accept=".xlx,.xls,.xlsx"
                        >
                            <template v-slot:default="{props, methods}">
                                <div class="flex justify-center items-center gap-3">
                                    <NextButton variant="outline-secondary" @click="methods.open"
                                                class="w-56 h-10 px-4 grow">
                                        <i class="icon icon-graffetta"></i> Allega
                                    </NextButton>
                                    <div class="flex gap-2">
                                        <div class="py-2">Esegui senza interrompere l'operazione in caso di errori</div>
                                        <Checkbox
                                            checkClass="h-4 w-4"
                                            :checked="skip_errors"
                                            @change="skip_errors = !skip_errors"
                                        >
                                        </Checkbox>
                                    </div>
                                </div>
                            </template>
                        </FileUpload>
                    </div>
                </div>
                <div v-if="uploaded" class="grid grid-cols-1 gap-3">
                    <a class="underline text-sm text-next-atp pt-3 cursor-pointer"
                       @click="downloadFile(f?.id)"
                       target="_blank"
                       v-for="(f,idx) in uploaded" :key="idx">
                        <span>{{ f.name }}</span>
                    </a>
                </div>

                <template v-if="record_importati >= 0">
                    <Alert class="mt-3 bg-next-bri">Record importati: {{ record_importati }}</Alert>
                </template>

                <template v-if="errors.length">
                    <Alert class="mt-3 bg-next-orange">Importazioni con errori</Alert>

                    <p v-for="e in errors" class="text-next-orange">{{ e }}</p>
                </template>

            </template>
            <template #footer>
                <div class="flex justify-end">
                    <div class="flex justify-end pt-3">
                        <NextButton variant="outline-secondary"
                                    @click="close"
                                    :disabled="loading"
                                    class="col-start-3 py-2 px-4">
                            Chiudi
                        </NextButton>
                        <NextButton variant="primary"
                                    :disabled="loading"
                                    @click="importa"
                                    class="py-2 px-4 w-full flex items-center justify-center ml-3">
                            <Spinner v-show="loading" class="w-4 h-4 mr-4"></Spinner>
                            Importa
                        </NextButton>
                    </div>
                </div>
            </template>
        </Modal>
    </teleport>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 flex justify-between">
                <h1 class="text-2xl font-bold">Lista Utenti</h1>
                <NextButton v-show="hasPermission('can_import_costi_timesheet')" @click="openModal" class="py-1 px-3">
                    Importa costi timesheet
                </NextButton>
            </div>
            <div class="grid grid-cols-4 gap-4 mb-3 items-center">
                <div class="flex flex-col col-span-2">
                    <Field field_name="Cerca" @update:modelValue="lista.debounceSearch" v-model="lista.search"
                           placeholder="Cerca"></Field>
                </div>
                <div class="flex flex-col col-span-2" v-if="hasPermission('delete users')">
                    <Checkbox for_id="deleted" :checked="show_deleted"
                              @change="onToggle" checkClass="w-5 h-5">Mostra cancellati
                    </Checkbox>
                </div>
            </div>
            <div class="flex justify-end">
                <Paginator class="" :pagination="lista.paginate"></Paginator>
            </div>
            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4"
                           v-model:cols="usersCols"
                           :rows="lista.rows" @order-update="lista.updateCols">
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_3`]>
                        {{ $filters.toDateTime(c.created_at) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_4`]>
                        {{ $filters.toDateTime(c.deleted_at) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                        <router-link :to="{name:'DettaglioUtente', params:{id:context.context.row.id}}"
                                     class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></router-link>
                    </template>
                </NextTable>

            </div>

            <InfiniteLoading @infinite="lista.fetchNextPage" :identifier="lista.infiniteIdentifier"
                             style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altri utenti.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import userManager from "@/api/Users";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import Field from "@/components/Field.vue";
import Lista from "@/setup/ListaCerca";
import Checkbox from "@/components/Checkbox.vue";
import {mapGetters} from "vuex";
import Paginator from "@/components/Paginator.vue";
import NextButton from "@/components/NextButton.vue";
import Modal from "@/components/Modal.vue";
import Radio from "@/components/Radio.vue";
import Alert from "@/components/Alert.vue";
import FileUpload from "@/components/FileUpload.vue";
import Spinner from "@/components/Spinner.vue";

@Options({
    name: 'ListaUtenti',
    components: {
        Spinner,
        FileUpload, Alert, Radio, Modal,
        NextButton,
        Paginator,
        Checkbox,
        Loading,
        Field,
        NextTable,
        InfiniteLoading
    },
    inject: ['downloadFile'],
    computed: {
        ...mapGetters([
            'me',
            'labelGender',
            'isNewBusiness',
            'hasPermission',
            'meCounters'
        ])
    },
})
export default class ListaUtenti extends Vue {
    cmOpener: any = setup(() => ContextMenuOpener())
    lista: any = setup(() => Lista(userManager, this.usersCols))
    visible = false
    show_deleted = true

    skip_errors = false
    uploaded: any[] = []
    errors: string[] = []
    loading: boolean = false
    record_importati: string | number = -1

    mounted() {
        this.refresh()
    }

    openModal(){
        this.record_importati = -1
        this.visible = true
    }

    refresh() {
        this.lista.apiParams['d'] = this.show_deleted ? 1 : 0
        this.lista.fetchData()
    }

    onToggle($event: any) {
        this.show_deleted = !this.show_deleted
        this.refresh()
    }

    importa() {
        this.errors = []
        this.loading = true
        if (!this.uploaded.length) {
            this.errors.push('Nessun file caricato')
            this.loading = false
            return
        }
        userManager.importaCostiTimesheet({file_id: this.uploaded[0].id, skip_errors:this.skip_errors}).then((res: any) => {
            this.uploaded = []
            this.refresh()
            this.record_importati = res.data.record_importati
            this.errors = res.data.errors
        }).catch((err: any) => {
            this.record_importati = -1
            this.errors = err.response.data.errors
        }).finally(() => {
            this.loading = false
        })
    }

    close() {
        this.visible = false
        this.uploaded = []
        this.record_importati = 0
        this.errors = []
    }

    usersCols = [
        {
            name: 'Nome utente',
            prop: 'name',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Email',
            prop: 'email',
            orderable: true,
            class: 'text-left ',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Business Unit',
            prop: 'bu_label',
            orderable: true,
            ordProp: 'business_units.nome',
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data creazione',
            prop: 'created_at',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data cancellazione',
            prop: 'deleted_at',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]
}

</script>


<style lang="scss">

</style>
